import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

interface ArrowProps {
  isAddressOpen: boolean;
}

export const Container = styled.div`
  margin: 60px 0;
`;

export const CenterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ArrowContainer = styled.div<ArrowProps>`
  cursor: pointer;
  margin-top: 20px;
  fill: ${({ theme }) => theme.colors.tertiary};
  transition: transform 0.5s;
  transform: rotate(
    ${({ isAddressOpen }) => (isAddressOpen ? "180deg" : "0deg")}
  );
`;

export const AddressesRow = styled.div<ArrowProps>`
  margin-top: 30px;
  display: ${({ isAddressOpen }) => (isAddressOpen ? "flex" : "none")};
  justify-content: space-between;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
  }
`;
